import React, { ReactNode, useCallback, useState } from 'react';
import { Text, Stack, Form } from 'rsuite';
import FormFieldErrorIcon from './FormFieldErrorIcon';
import {
  RadioGroupWithErrorStatus,
  RadioGroupWithErrorStatusProps,
} from './RadioGroupWithErrorStatus';

export interface RadioQuestionGroupProps {
  name: string;
  title?: string | ReactNode;
  description?: string | ReactNode;
  options: any[];
  defaultOption: any;
  onChange: (value: any) => void;
  hasError: boolean;
  validationRule: any;
  errorMessage?: string;
  hideErrorIcon?: boolean;
  disabled?: boolean;
  value?: any;
  className?: string;
}

const RadioQuestionGroup = ({
  name,
  title = '',
  description = '',
  options,
  defaultOption,
  onChange,
  hasError,
  validationRule,
  errorMessage = '',
  hideErrorIcon = false,
  disabled = false,
  ...rest
}: RadioQuestionGroupProps) => {
  const RadioGroupWithErrorStateAndProps = useCallback(
    (props: RadioGroupWithErrorStatusProps) => (
      <RadioGroupWithErrorStatus
        {...props}
        options={options}
        defaultOption={defaultOption}
        onChange={changedInternal}
        disabled={disabled}
      />
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [hasError, errorMessage, hideErrorIcon, defaultOption, options]
  );
  const [isChanged, setIsChanged] = useState(false);

  const changedInternal = (v: any) => {
    setIsChanged(true);
    onChange(v);
  };

  return (
    <>
      <Stack
        direction="row"
        {...rest}
      >
        <Stack
          direction="column"
          alignItems="flex-start"
        >
          {title && <Text className="text-bold">{title}</Text>}
          {description && <Text>{description}</Text>}
          <Form.Control
            name={name}
            rule={validationRule}
            errorMessage={errorMessage}
            accepter={RadioGroupWithErrorStateAndProps}
            {...rest}
            disabled={disabled}
          />
        </Stack>
        {hasError && !isChanged && (
          <FormFieldErrorIcon errorMessage={errorMessage} />
        )}
      </Stack>
    </>
  );
};

export default RadioQuestionGroup;
